<template>
    <div class="forgot-password login-page" id="login">
        <div class="login-content">
            <div class="login-logo text-center">
                <img :src="imagePath" alt="DealerPro Application">
            </div>
            <div class="login-container">
                <h2 class="mb-3">Reset your password.</h2>
                <div class="form-row">
                    <div class="col form-group">
                        <input name="password" v-model="password" id="password" class="form-control" placeholder="New Password" type="password">
                        <div class="field-error">{{ password_error_msg }}</div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col form-group">
                        <input name="confirmpassword" v-model="confirmpassword" id="confirmpassword" class="form-control" placeholder="Confirm Password" type="password">
                        <div class="field-error">{{ confirmpassword_error_msg }}</div>
                    </div>
                </div>
                <div class="alert alert-warning hide form-group" id="alertError">
                    <button type="button" class="close" @click="hideAlert()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="error-msg" class="field-error"></strong>
                </div>
                <div class="btn-groups mt-4">
                    <button class="btn btn-tertiary" v-on:click="loginPage()">Back</button>
                    <button id="resetPassbtn" class="btn btn-primary" style="margin-left:5px;" type="submit" v-on:click="ResetPassword()">Submit</button>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    import EventBus from './event-bus.js';

    export default {
        name: "ResetPassword",
        data: () => ({
            password_error_msg : "",
            confirmpassword_error_msg: "",
            password: "",
            confirmpassword: "",
            error:"",
            userToekn: "",
            username: "",
            imagePath: process.env.LOGO_PATH,
        }),
        created: function() {

        },
        mounted: function() {

            //hide header
            var self = this;
            self.userToekn = this.$route.params.token;

            self.checkToken();
            
            EventBus.$emit('logged-in', false,"","","");

            $(document).ready(function(){
                $("#login").height($(window).height() + 'px');
            });
            $(window).resize(function(){
                $("#login").height($(window).height() + 'px');
            });
            $("input").keypress(function(e) {
                if (e.keyCode === 13) {
                    if (e.target.id == 'confirmpassword' || e.target.id == 'password') {
                        self.ResetPassword();
                    }
                }
            });
        },
        methods: {
            hideAlert(){
                $(".alert-warning").addClass("hide");
                $(".alert-warning").removeClass("show");
            },
            checkToken(){
                var self = this;
                if (
                    self.userToekn != undefined 
                    && 
                    self.userToekn != ""
                ) {
                    $.ajax({
                        url: process.env.ROOT_API + "/checkuser",
                        type: "GET",
                        crossDomain: true,
                        data: {
                            tokenValue: self.userToekn,
                            flag: 'reset'
                        },
                        dataType: 'json',
                        success: function (data) {
                            if (data.code === 201) {
                                const errorMessage = "The token is incorrect. Please try again.";

                                self.$swal({
                                    title: data.message || "Error",
                                    text: errorMessage,
                                    type: "error",
                                    confirmButtonText: "Ok",
                                    showCloseButton: false
                                }).then(result => {
                                    self.$router.push("/");
                                });
                            }
                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.registerError = "Remote server cannot be reached";
                            }
                        }
                    });
                }
            },
            loginPage() {
                var self = this;
                self.$router.push("/");
            },

            ResetPassword: function () {

                var self = this;
                self.password_error_msg = "";
                self.confirmpassword_error_msg = "";

                var error = false;

                if (!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = self.passReq;
                    error = true;
                }

                if (!self.confirmpassword || self.confirmpassword == null || self.confirmpassword == "") {
                    self.confirmpassword_error_msg = self.confPassReqErr;
                    error = true;
                }

                if (self.password != self.confirmpassword && self.confirmpassword !="") {
                    self.confirmpassword_error_msg = "";
                    self.confirmpassword_error_msg = self.confPassMatchErr;
                    error = true;
                }

                if (!error) {

                    $("#resetPassbtn").attr("disable",true);
                    $("#resetPassbtn").text("Submiting...");

                    $.ajax({
                        url: process.env.ROOT_API + "/forgot-password",
                        type: "POST",
                        crossDomain: true,
                        dataType: 'json',
                        data: {
                            token: self.userToekn,
                            password: self.password
                        },
                        success: function (data) {
                            $("#resetPassbtn").text("Submit");
                            $("#resetPassbtn").attr("disable",false);
                            if (data.status == "success") {
                                self.$swal({
                                    title: "Password reset successfully!",
                                    type: "success",
                                    confirmButtonText: "Okay",
                                }).then(result => {
                                    self.$router.push("/");
                                });
                            } else {                                
                                $("#error-msg").html(data.message.password[0] || data.message);
                                $(".alert-warning").removeClass("hide");
                                $(".alert-warning").addClass("show");
                            }
                        },
                        error: function (xhr, exception) {

                            // self.Loginbtn = "Login";
                            $("#resetPassbtn").text("Submit");
                            $("#resetPassbtn").attr("disable",false);
                            if (xhr.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                self.error = jQuery.parseJSON(xhr.responseText).message;
                            }
                        }
                    });
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue